import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNotification } from '../context/NotificationContext';

const useBackButton = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { showSuccess } = useNotification();

    useEffect(() => {
        let lastBackPress = 0;

        const handleBackButton = async ({ canGoBack }) => {
            const path = location.pathname;

            // Root paths where back button should exit app (or ask confirmation)
            const rootPaths = [
                '/role-selection',
                '/login',
                '/patient/home',
                '/doctor/home',
                '/dashboard/admin/home',
                '/dashboard/hospital/home',
                '/dashboard/clinic/home',
                '/dashboard/retailer/home'
            ];

            if (rootPaths.some(root => path.includes(root)) || path === '/') {
                const now = Date.now();
                if (now - lastBackPress < 2000) {
                    App.exitApp();
                } else {
                    showSuccess('Press back again to exit');
                    lastBackPress = now;
                }
            } else {
                // Go back in history
                navigate(-1);
            }
        };

        const listener = App.addListener('backButton', handleBackButton);

        return () => {
            listener.then(handler => handler.remove());
        };
    }, [navigate, location, showSuccess]);
};

export default useBackButton;
